<template>
  <div class="row job-site-filter">
    <div class="col-sm-12 basic-filters">
      <label>{{ label }}</label>
      <AppSelect
        v-model="selected"
        :options="options"
        :select2-options="select2Options"
      ></AppSelect>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportJobSiteFilter',
  props: {
    label: {
      type: String,
      default: 'Job Sites',
    },
  },
  data() {
    return {
      select2Options: {
        allowClear: true,
        placeholder: 'All job sites',
        multiple: true,
        width: '100%',
      },
    };
  },
  computed: {
    options() {
      const archived_data = [];
      const result = [];

      this.allJobSites.forEach((jobSite) => {
        (jobSite.archived ? archived_data : result).push({
          id: jobSite.id,
          text: jobSite.name,
        });
      });
      if (archived_data.length > 0) {
        result.push({
          text: 'Archived',
          children: archived_data,
        });
      }

      return result;
    },
    selected: {
      get() {
        return this.$store.state.report_query.filters.job_sites || [];
      },
      set(job_sites) {
        this.$store.dispatch('updateSearch', { job_sites });
      },
    },
    ...mapGetters(['allJobSites']),
  },
};
</script>
